import { withStyles } from '@material-ui/core';

import styles from '../SingleReceiptForm/styles';
import ReceiptsCountForm from './component';

export default withStyles(styles)(ReceiptsCountForm);
